import react from "../../assets/Frameworks/react.png";

const express = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg';

const LibJsElements = [
  { id: 1, path: react, title: "React", style: "shadow-blue-400" },
  { id: 2, path: express, title: "Express.js", style: "shadow-gray-400", imgClass: "brightness-0 invert" },
];

export default LibJsElements;
